/**
 * Light and dark themes. The choice is stored per browser; until someone picks
 * one, the OS preference decides. index.html applies the same rule inline before
 * first paint, so keep THEME_KEY in sync with it.
 */
export type Theme = 'light' | 'dark';

export const THEME_KEY = 'prisma.theme';

export const savedTheme = (): Theme | null => {
  try {
    const v = localStorage.getItem(THEME_KEY);
    return v === 'light' || v === 'dark' ? v : null;
  } catch {
    return null; // storage blocked (private mode, policy)
  }
};

export const systemTheme = (): Theme =>
  window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';

export const currentTheme = (): Theme =>
  document.documentElement.dataset.theme === 'dark' ? 'dark' : 'light';

export const applyTheme = (theme: Theme) => {
  document.documentElement.dataset.theme = theme;
};

export const saveTheme = (theme: Theme) => {
  applyTheme(theme);
  try {
    localStorage.setItem(THEME_KEY, theme);
  } catch {
    /* the theme still applies for this page view */
  }
};
